import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class AppointmentConfirmationSettingsRecord extends RecordBase {
  static defaultAttributes = {
    appointment_confirmation_enabled: false,
    appointment_confirmation_template: '',
    appointment_confirmation_contact: '',
  };

  static _attributeNames = null;

  static get attributeNames() {
    const { t } = useTranslation();
    const trAttr = (attr) => t(`appointmentConfirmation.attributes.${attr}`);
    if (!this._attributeNames) {
      this._attributeNames = {
        appointment_confirmation_enabled: trAttr('appointment_confirmation_enabled'),
        appointment_confirmation_template: trAttr('appointment_confirmation_template'),
        appointment_confirmation_contact: trAttr('appointment_confirmation_contact'),
      };
    }
    return this._attributeNames;
  }

  toParams() {
    const {
      appointment_confirmation_enabled,
      appointment_confirmation_template,
      appointment_confirmation_contact,
    } = this.toObject();
    return {
      data: {
        attributes: {
          appointment_confirmation_enabled,
          appointment_confirmation_template: appointment_confirmation_template || '',
          appointment_confirmation_contact: appointment_confirmation_contact || '',
        },
      },
    };
  }
}
